const FAVICON_SERVICE_BASE = 'https://www.google.com/s2/favicons';

export const createFaviconUrl = (domain: string, size: number = 18) => {
  const params = new URLSearchParams({
    domain,
    sz: size.toString(),
  });
  return `${FAVICON_SERVICE_BASE}?${params.toString()}`;
};
